import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { SectionHeader } from '../components/SectionHeader';
import { blogPosts } from '../data/content';
import { blogImageMap, images } from '../data/images';
import { ArrowRight } from 'lucide-react';
export function Blog() {
  const featuredPost = blogPosts[0];
  const remainingPosts = blogPosts.slice(1);
  return <div className="pt-32 pb-24 bg-[#F2E8D5] min-h-screen text-midnight" data-id="element-327">
      <div className="container mx-auto px-6" data-id="element-328">
        <div className="text-center mb-20" data-id="element-329">
          <span className="text-[11px] font-bold tracking-[0.2em] uppercase text-gold-dark mb-4 block" data-id="element-330">
            Sacred Practices
          </span>
          <h1 className="text-5xl md:text-6xl font-serif text-midnight mb-6" data-id="element-331">
            Journal & Insights
          </h1>
          <p className="text-lg text-midnight/60 max-w-2xl mx-auto" data-id="element-332">
            Explore articles on healing, astrology, and spiritual growth to
            support your daily journey.
          </p>
        </div>

        {/* Featured Post */}
        <motion.article initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-20 group cursor-pointer" data-id="element-333">
          <Link to={`/blog/${featuredPost.title.toLowerCase().replace(/\s+/g, '-')}`} className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-334">
            <div className="aspect-[4/3] lg:aspect-[16/9] rounded-[2rem] overflow-hidden relative shadow-2xl" data-id="element-335">
              <div className="absolute inset-0 bg-cover bg-center group-hover:scale-105 transition-transform duration-700" style={{
              backgroundImage: `url(${blogImageMap[featuredPost.title] || images.cosmicAbstract})`
            }} data-id="element-336"></div>
              <div className="absolute inset-0 bg-gradient-to-tr from-midnight/40 via-transparent to-transparent" data-id="element-337"></div>
              <div className="absolute top-6 left-6 bg-midnight/80 backdrop-blur-md text-gold px-4 py-2 rounded-full text-[10px] font-bold uppercase tracking-widest border border-gold/30" data-id="element-338">
                Featured Story
              </div>
            </div>
            <div data-id="element-339">
              <div className="flex items-center gap-3 text-xs font-bold uppercase tracking-widest text-gold-dark mb-6" data-id="element-340">
                <span className="px-3 py-1 border border-gold-dark rounded-full" data-id="element-341">
                  {featuredPost.category}
                </span>
                <span data-id="element-342">{featuredPost.date}</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-serif text-midnight mb-6 group-hover:text-gold-dark transition-colors leading-tight" data-id="element-343">
                {featuredPost.title}
              </h2>
              <p className="text-lg text-midnight/70 mb-8 leading-relaxed" data-id="element-344">
                {featuredPost.excerpt}
              </p>
              <div className="inline-flex items-center gap-2 font-bold text-midnight group-hover:text-gold-dark transition-colors uppercase tracking-wider text-sm" data-id="element-345">
                Read Article{' '}
                <ArrowRight className="w-4 h-4 group-hover:translate-x-2 transition-transform" data-id="element-346" />
              </div>
            </div>
          </Link>
        </motion.article>

        <div className="w-full h-px bg-midnight/10 mb-20" data-id="element-347"></div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12" data-id="element-348">
          {remainingPosts.map((post, i) => <motion.article key={post.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="group cursor-pointer" data-id="element-349">
              <Link to={`/blog/${post.title.toLowerCase().replace(/\s+/g, '-')}`} data-id="element-350">
                <div className="aspect-[4/3] rounded-[2rem] bg-midnight/5 mb-8 overflow-hidden relative shadow-lg" data-id="element-351">
                  <div className="absolute inset-0 bg-cover bg-center group-hover:scale-105 transition-transform duration-700" style={{
                backgroundImage: `url(${blogImageMap[post.title] || images.cosmicAbstract})`
              }} data-id="element-352"></div>
                  <div className="absolute inset-0 bg-gradient-to-t from-midnight/30 via-transparent to-transparent" data-id="element-353"></div>
                </div>

                <div className="flex items-center gap-3 text-xs font-bold uppercase tracking-widest text-gold-dark mb-4" data-id="element-354">
                  <span data-id="element-355">{post.category}</span>
                  <span className="w-1 h-1 rounded-full bg-midnight/20" data-id="element-356"></span>
                  <span data-id="element-357">{post.date}</span>
                </div>

                <h3 className="text-2xl font-serif text-midnight mb-4 group-hover:text-gold-dark transition-colors leading-snug" data-id="element-358">
                  {post.title}
                </h3>

                <p className="text-midnight/60 mb-6 line-clamp-2" data-id="element-359">
                  {post.excerpt}
                </p>
              </Link>
            </motion.article>)}
        </div>
      </div>
    </div>;
}